export enum FilterTagType {
  default = 'default',
  highSeverity = 'high-severity',
  highSeverityAlternate = 'high-severity-alt',
  moderateSeverity = 'moderate-severity',
  moderateSeverityAlternate = 'moderate-severity-alt',
  lowSeverity = 'low-severity',
  lowSeverityAlternate = 'low-severity-alt-a',
  success = 'success',
  infoOption1 = 'info-option-1',
  infoOption2 = 'info-option-2',
  infoOption3 = 'info-option-3',
  infoOption4 = 'info-option-4',
  infoOption5 = 'info-option-5'
}
